import { createContext, useState } from 'react';
import { LanguageOverrideProvider, useLanguage } from '../contexts/LanguageContext';

export const ReviewModalFloatingSlotContext = createContext(null);

export default function ReviewModal({ children, onClose, forceEnglish = false }) {
  const [floatingSlot, setFloatingSlot] = useState(null);
  const { t } = useLanguage();

  const shell = (
    <ReviewModalFloatingSlotContext.Provider value={floatingSlot}>
      <div
        className="fixed inset-x-0 top-0 z-[100] flex h-[100dvh] overflow-hidden bg-gray-900/50 p-3 sm:p-4"
        dir={forceEnglish ? 'ltr' : undefined}
        lang={forceEnglish ? 'en' : undefined}
      >
        <div className="mx-auto flex h-full min-h-0 w-full max-w-review flex-col items-center md:max-w-review-lg lg:max-w-review-xl">
          <div
            className="relative flex min-h-0 w-full flex-1 flex-col overflow-hidden rounded-[24px] bg-surface shadow-modal review-modal"
            style={{
              WebkitMaskImage: '-webkit-radial-gradient(white, black)',
              isolation: 'isolate',
            }}
          >
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="absolute right-4 top-4 z-10 rounded-full bg-gray-100 px-3 py-1 text-sm text-gray-600"
              >
                {forceEnglish ? 'Close' : t('close')}
              </button>
            )}
            {children}
          </div>
          <div
            ref={setFloatingSlot}
            className="flex w-full shrink-0 justify-center pt-3 pb-[env(safe-area-inset-bottom,0px)]"
          />
        </div>
      </div>
    </ReviewModalFloatingSlotContext.Provider>
  );

  if (!forceEnglish) return shell;

  return <LanguageOverrideProvider language="en">{shell}</LanguageOverrideProvider>;
}
